export default function useKidTypesFromPrices(prices) {

    if (!prices) {
        return null;
    }   
    
    return [...new Set(prices.map(p => Object.keys(p).filter(t => !!p[t].kids)).flat())];
}